// InputCheckboxButton.tsx
import React, { useState } from "react";

interface InputCheckboxButtonProps extends React.InputHTMLAttributes<HTMLInputElement> {
  onClick?: (any) => void;
  text?: string;
}

const InputCheckboxButton = ({
  text,
  onClick,
  checked,
  disabled,
  ...others
}: InputCheckboxButtonProps) => {
  const [checkState, setCheckedState] = useState(checked ?? false);

  const handleChecked: React.MouseEventHandler<HTMLButtonElement | HTMLInputElement> = (e) => {
    if (onClick) {
      onClick(e);
    }
    setCheckedState(!checkState);
  };

  const buttonStyles = `
    relative basis-auto whitespace-nowrap inline-flex justify-center items-center 
    px-4 py-2.5 -ml-px gap-x-1.5 rounded-r-md 
    text-sm font-semibold text-gray-900 
    ring-1 ring-inset ring-gray-300 bg-neutral-100
    disabled:ring-gray-200 disabled:bg-neutral-0 [&_span]:disabled:text-gray-400
  `;

  return (
    <button type="button" className={buttonStyles} onClick={handleChecked} disabled={disabled}>
      <input
        type="checkbox"
        checked={checkState}
        onChange={() => {}} // Required for controlled component, actual change handled by onClick
        onClick={handleChecked}
        disabled={disabled}
        className="rounded mr-1 focus:ring-0 focus:ring-offset-0 border-gray-300 checked:text-primary-600 disabled:checked:text-primary-200"
        {...others}
      />
      {text && <span className="text-gray-600">{text}</span>}
    </button>
  );
};

export default InputCheckboxButton;
